export const env = {
  api: "https://guvi-capstone-back-end.vercel.app",
};
// https://guvi-capstone-back-end.vercel.app
// http://localhost:3001
